import { useQuery } from "@tanstack/react-query";
import fetchApi from "../fetchApi";
import { ErrorResponse } from "../../models/apiResponse";
import { CorporateService } from "../../models/Service";

const useQueryService = ({
  corporateId,
  enabled = true,
  authorisation = "",
}: {
  corporateId: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    [`/corporate-subsidiary/${corporateId}/corporate-service`],
    () =>
      fetchApi(`corporate-subsidiary/${corporateId}/corporate-service`, {
        headers: {
          Authorization: `Bearer ${authorisation}`,
        },
      }).get<CorporateService[] | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export const useQueryServiceByServiceId = ({
  corporateId,
  serviceId,
  enabled = true,
  authorisation = "",
}: {
  corporateId: string;
  serviceId: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    [`/corporate-subsidiary/${corporateId}/corporate-service/${serviceId}`],
    () =>
      fetchApi(
        `corporate-subsidiary/${corporateId}/corporate-service/${serviceId}`,
        {
          headers: {
            Authorization: `Bearer ${authorisation}`,
          },
        }
      ).get<CorporateService | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export default useQueryService;
